// RequireAccess — route-element guard for the Phase 4 router tail.
//
// docs/portal-architecture-refactor-plan.md §2.4 / Phase 4: each top-level route
// element is wrapped in this guard so the SAME `access.ts` policy that drives the
// nav also gates rendering. If the current user may not see `screen`, redirect to
// their default screen instead of rendering it (closes the old deep-link / ternary
// fall-through holes — see access.ts D-A/D-B).
//
// Built and tested standalone first (this commit makes NO change to portal.jsx's
// render); the ternary → <Routes> conversion that uses it lands in the next slice.
//
// Usage (next slice):
//   <Route path="/admin" element={<RequireAccess screen="admin"><AdminDash/></RequireAccess>} />

import { Navigate } from "react-router-dom";
import { canAccess, defaultScreenFor } from "./access";
import { useSession } from "./SessionContext.jsx";

export function RequireAccess({ screen, children }) {
  const { user } = useSession();
  if (!canAccess(user, screen)) {
    return <Navigate to={`/${defaultScreenFor(user)}`} replace />;
  }
  return children;
}
